export default __webpack_public_path__ + "static/media/error.52239391.png";